/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { DeviceCoverageAudioChannelFragment } from './device-coverage-audio-channel.generated';
import { DeviceCoverageAudioCoverageAreaFragment } from './device-coverage-audio-area.generated';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeviceCoverageDeviceFragment = { id: string, virtual: boolean, status: Types.DeviceStatus, isDeviceNode: 'Device', description: { model: string, features: { authentication: { supported: boolean }, audioCoverageAreas: { supported: boolean }, audioChannels: { supported: boolean }, analogAudioOutputMode: { supported: boolean }, coverageMode: { supported: boolean }, debugMode: { supported: boolean }, dspDebugMode: { supported: boolean }, placement: { supported: boolean }, detectedPlacement: { supported: boolean }, coveragePosition: { supported: boolean }, height: { supported: boolean }, listenerHeight: { supported: boolean }, rotation: { supported: boolean }, orientation: { supported: boolean }, audioAutoFocus: { supported: boolean }, identify: { supported: boolean }, name: { supported: boolean }, talkerTrackingConfig: { supported: boolean }, talkerTracking: { supported: boolean }, coverageViewLock: { supported: boolean }, automixGainMetering: { supported: boolean }, audioMute: { supported: boolean }, danteAudioNetwork: { supported: boolean }, userPerspective: { supported: boolean }, userInterfacePreferences: { supported: boolean } }, constraints: { talkerTrackingConfig: { positionUpdateRate: { range: { max: number, min: number, step: number } } } | null, height: { height: { range: { max: number, min: number, step: number } } } | null, name: { name: { pattern: string | null } } | null } }, features: { authentication: { credentials: Array<{ accessLevel: string, credentialsState: Types.CredentialsState }> | null } | null, audioChannels: { audioChannels: Array<DeviceCoverageAudioChannelFragment> } | null, audioCoverageAreas: { audioCoverageAreas: Array<DeviceCoverageAudioCoverageAreaFragment> } | null, analogAudioOutputMode: { mode: Types.AnalogAudioOutputMode } | null, coverageMode: { coverageMode: Types.CoverageMode } | null, debugMode: { enabled: boolean } | null, dspDebugMode: { enabled: boolean } | null, height: { height: number } | null, listenerHeight: { height: number } | null, placement: { placement: Types.Placement } | null, detectedPlacement: { detectedPlacement: Types.DetectedPlacement | null } | null, coveragePosition: { xPosition: number | null, yPosition: number | null } | null, rotation: { xAxis: number, yAxis: number, zAxis: number } | null, orientation: { xAxis: number, yAxis: number, zAxis: number } | null, audioAutoFocus: { enabled: boolean } | null, identify: { identifying: boolean } | null, name: { name: string } | null, talkerTrackingConfig: { localizationSensitivity: Types.LocalizationSensitivity, metricsIncluded: boolean, positionUpdateRate: number | null, reflectionCorrection: Types.ReflectionCorrection, voiceActivityDetectionSensitivity: Types.VoiceActivityDetectionSensitivity } | null, coverageViewLock: { enabled: boolean } | null, automixGainMetering: { enabled: boolean } | null, audioMute: { muted: boolean } | null, danteAudioNetwork: { name: string } | null, userPerspective: { deviceRotation: { xAxis: number, yAxis: number, zAxis: number }, viewRotation: { angle: number } } | null, userInterfacePreferences: { unitOfMeasurement: { distance: Types.DistanceMeasurement } | null } | null } };

export type DeviceCoverageDeviceUpdateFragment = { id: string, features:
    | { analogAudioOutputMode: { mode: Types.AnalogAudioOutputMode } | null }
    | { audioAutoFocus: { enabled: boolean } | null }
    | { automixGainMetering: { enabled: boolean } | null }
    | { coverageMode: { coverageMode: Types.CoverageMode } | null }
    | { coveragePosition: { xPosition: number | null, yPosition: number | null } | null }
    | { coverageViewLock: { enabled: boolean } | null }
    | { debugMode: { enabled: boolean } | null }
    | { detectedPlacement: { detectedPlacement: Types.DetectedPlacement | null } | null }
    | { dspDebugMode: { enabled: boolean } | null }
    | { height: { height: number } | null }
    | { identify: { identifying: boolean } | null }
    | { listenerHeight: { height: number } | null }
    | { orientation: { xAxis: number, yAxis: number, zAxis: number } | null }
    | { placement: { placement: Types.Placement } | null }
    | { rotation: { xAxis: number, yAxis: number, zAxis: number } | null }
    | { talkerTrackingConfig: { localizationSensitivity: Types.LocalizationSensitivity, metricsIncluded: boolean, positionUpdateRate: number | null, reflectionCorrection: Types.ReflectionCorrection, voiceActivityDetectionSensitivity: Types.VoiceActivityDetectionSensitivity } | null }
    | { userInterfacePreferences: { unitOfMeasurement: { distance: Types.DistanceMeasurement } | null } | null }
    | { userPerspective: { deviceRotation: { xAxis: number, yAxis: number, zAxis: number }, viewRotation: { angle: number } } | null }
    | Record<PropertyKey, never>
   };

export type GetCoverageDeviceQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetCoverageDeviceQueryOpResult = { node:
    | DeviceCoverageDeviceFragment
    | Record<PropertyKey, never>
   };

export type CoverageDeviceSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type CoverageDeviceSubscriptionOpResult = { nodeChanges:
    | DeviceCoverageDeviceFragment
    | DeviceCoverageDeviceUpdateFragment
    | Record<PropertyKey, never>
   };

export type TalkerTrackingPositionSubscriptionVariables = Types.Exact<{
  deviceTalkerTrackingId: Types.Scalars['ID']['input'];
}>;


export type TalkerTrackingPositionSubscriptionOpResult = { deviceTalkerTracking: { talkers: Array<
      | { position: { confidenceLevel: number | null, xPosition: number, yPosition: number, zPosition: number } }
      | { position: { confidenceLevel: number | null, xPosition: number, yPosition: number, zPosition: number } }
    > } };

export type UpdateCoverageDeviceMutationVariables = Types.Exact<{
  updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateCoverageDeviceMutationOpResult = { updateNodes: Array<
    | { error: { code: Types.ErrorCode, message: string } | null }
    | Record<PropertyKey, never>
  > };

export type ResetDeviceMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  scope: Types.DeviceResetScope;
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ResetDeviceMutationOpResult = { resetDevice:
    | { error: { code: Types.ErrorCode, message: string } | null }
    | Record<PropertyKey, never>
   };

export type UpdateUserInterfacePreferencesMutationVariables = Types.Exact<{
  input: Types.DeviceUserInterfacePreferencesUpdateInput;
}>;


export type UpdateUserInterfacePreferencesMutationOpResult = { updateUserInterfacePreferences: { error: { code: Types.ErrorCode, message: string } | null } };

export const DeviceCoverageDeviceFragment = gql`
    fragment DeviceCoverageDeviceFragment on Device {
  isDeviceNode: __typename
  id
  virtual
  status
  description {
    model
    features {
      authentication {
        supported
      }
      audioCoverageAreas {
        supported
      }
      audioChannels {
        supported
      }
      analogAudioOutputMode {
        supported
      }
      coverageMode {
        supported
      }
      debugMode {
        supported
      }
      dspDebugMode {
        supported
      }
      placement {
        supported
      }
      detectedPlacement {
        supported
      }
      coveragePosition {
        supported
      }
      height {
        supported
      }
      listenerHeight {
        supported
      }
      rotation {
        supported
      }
      orientation {
        supported
      }
      audioAutoFocus {
        supported
      }
      identify {
        supported
      }
      name {
        supported
      }
      talkerTrackingConfig {
        supported
      }
      talkerTracking {
        supported
      }
      coverageViewLock {
        supported
      }
      automixGainMetering {
        supported
      }
      audioMute {
        supported
      }
      danteAudioNetwork {
        supported
      }
      userPerspective {
        supported
      }
      userInterfacePreferences {
        supported
      }
    }
    constraints {
      talkerTrackingConfig {
        positionUpdateRate {
          range {
            max
            min
            step
          }
        }
      }
      height {
        height {
          range {
            max
            min
            step
          }
        }
      }
      name {
        name {
          pattern
        }
      }
    }
  }
  features {
    authentication {
      credentials {
        accessLevel
        credentialsState
      }
    }
    audioChannels {
      audioChannels {
        ... on AudioChannel {
          ...DeviceCoverageAudioChannelFragment
        }
      }
    }
    audioCoverageAreas {
      audioCoverageAreas {
        ... on AudioCoverageArea {
          ...DeviceCoverageAudioCoverageAreaFragment
        }
      }
    }
    analogAudioOutputMode {
      mode
    }
    coverageMode {
      coverageMode
    }
    debugMode {
      enabled
    }
    dspDebugMode {
      enabled
    }
    height {
      height
    }
    listenerHeight {
      height
    }
    placement {
      placement
    }
    detectedPlacement {
      detectedPlacement
    }
    coveragePosition {
      xPosition
      yPosition
    }
    rotation {
      xAxis
      yAxis
      zAxis
    }
    orientation {
      xAxis
      yAxis
      zAxis
    }
    audioAutoFocus {
      enabled
    }
    identify {
      identifying
    }
    name {
      name
    }
    talkerTrackingConfig {
      localizationSensitivity
      metricsIncluded
      positionUpdateRate
      reflectionCorrection
      voiceActivityDetectionSensitivity
    }
    coverageViewLock {
      enabled
    }
    automixGainMetering {
      enabled
    }
    audioMute {
      muted
    }
    danteAudioNetwork {
      name
    }
    userPerspective {
      deviceRotation {
        xAxis
        yAxis
        zAxis
      }
      viewRotation {
        angle
      }
    }
    userInterfacePreferences {
      unitOfMeasurement {
        distance
      }
    }
  }
}
    ${DeviceCoverageAudioChannelFragment}
${DeviceCoverageAudioCoverageAreaFragment}`;
export const DeviceCoverageDeviceUpdateFragment = gql`
    fragment DeviceCoverageDeviceUpdateFragment on DeviceChange {
  id
  features {
    ... on DeviceAnalogAudioOutputModeChange {
      analogAudioOutputMode {
        mode
      }
    }
    ... on DeviceCoverageModeChange {
      coverageMode {
        coverageMode
      }
    }
    ... on DevicePlacementChange {
      placement {
        placement
      }
    }
    ... on DeviceDetectedPlacementChange {
      detectedPlacement {
        detectedPlacement
      }
    }
    ... on DeviceCoveragePositionChange {
      coveragePosition {
        xPosition
        yPosition
      }
    }
    ... on DeviceHeightChange {
      height {
        height
      }
    }
    ... on DeviceListenerHeightChange {
      listenerHeight {
        height
      }
    }
    ... on DeviceRotationChange {
      rotation {
        xAxis
        yAxis
        zAxis
      }
    }
    ... on DeviceOrientationChange {
      orientation {
        xAxis
        yAxis
        zAxis
      }
    }
    ... on DeviceIdentifyChange {
      identify {
        identifying
      }
    }
    ... on DeviceAudioAutoFocusChange {
      audioAutoFocus {
        enabled
      }
    }
    ... on DeviceTalkerTrackingConfigChange {
      talkerTrackingConfig {
        localizationSensitivity
        metricsIncluded
        positionUpdateRate
        reflectionCorrection
        voiceActivityDetectionSensitivity
      }
    }
    ... on DeviceDspDebugModeChange {
      dspDebugMode {
        enabled
      }
    }
    ... on DeviceDebugModeChange {
      debugMode {
        enabled
      }
    }
    ... on DeviceCoverageViewLockChange {
      coverageViewLock {
        enabled
      }
    }
    ... on DeviceAutomixGainMeteringChange {
      automixGainMetering {
        enabled
      }
    }
    ... on DeviceUserPerspectiveChange {
      userPerspective {
        deviceRotation {
          xAxis
          yAxis
          zAxis
        }
        viewRotation {
          angle
        }
      }
    }
    ... on DeviceUserInterfacePreferencesChange {
      userInterfacePreferences {
        unitOfMeasurement {
          distance
        }
      }
    }
  }
}
    `;
export const GetCoverageDeviceQueryDocument = gql`
    query GetCoverageDeviceQuery($id: ID!) {
  node(id: $id) {
    ...DeviceCoverageDeviceFragment
  }
}
    ${DeviceCoverageDeviceFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCoverageDeviceQueryGQL extends Apollo.Query<GetCoverageDeviceQueryOpResult, GetCoverageDeviceQueryVariables> {
    override document = GetCoverageDeviceQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CoverageDeviceSubscriptionDocument = gql`
    subscription CoverageDeviceSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ...DeviceCoverageDeviceFragment
    ...DeviceCoverageDeviceUpdateFragment
  }
}
    ${DeviceCoverageDeviceFragment}
${DeviceCoverageDeviceUpdateFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CoverageDeviceSubscriptionGQL extends Apollo.Subscription<CoverageDeviceSubscriptionOpResult, CoverageDeviceSubscriptionVariables> {
    override document = CoverageDeviceSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TalkerTrackingPositionSubscriptionDocument = gql`
    subscription TalkerTrackingPositionSubscription($deviceTalkerTrackingId: ID!) {
  deviceTalkerTracking(id: $deviceTalkerTrackingId) {
    talkers {
      ... on AudioChannelTalker {
        position {
          confidenceLevel
          xPosition
          yPosition
          zPosition
        }
      }
      ... on AudioCoverageAreaTalker {
        position {
          confidenceLevel
          xPosition
          yPosition
          zPosition
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TalkerTrackingPositionSubscriptionGQL extends Apollo.Subscription<TalkerTrackingPositionSubscriptionOpResult, TalkerTrackingPositionSubscriptionVariables> {
    override document = TalkerTrackingPositionSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCoverageDeviceMutationDocument = gql`
    mutation UpdateCoverageDeviceMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
  updateNodes(updates: $updates, keyring: $injectKeyring) {
    ... on DeviceOperationResult {
      error {
        code
        message
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCoverageDeviceMutationGQL extends Apollo.Mutation<UpdateCoverageDeviceMutationOpResult, UpdateCoverageDeviceMutationVariables> {
    override document = UpdateCoverageDeviceMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetDeviceMutationDocument = gql`
    mutation ResetDeviceMutation($id: ID!, $scope: DeviceResetScope!, $injectKeyring: String) {
  resetDevice(id: $id, scope: $scope, keyring: $injectKeyring) {
    ... on DeviceOperationResult {
      error {
        code
        message
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetDeviceMutationGQL extends Apollo.Mutation<ResetDeviceMutationOpResult, ResetDeviceMutationVariables> {
    override document = ResetDeviceMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserInterfacePreferencesMutationDocument = gql`
    mutation UpdateUserInterfacePreferencesMutation($input: DeviceUserInterfacePreferencesUpdateInput!) {
  updateUserInterfacePreferences(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserInterfacePreferencesMutationGQL extends Apollo.Mutation<UpdateUserInterfacePreferencesMutationOpResult, UpdateUserInterfacePreferencesMutationVariables> {
    override document = UpdateUserInterfacePreferencesMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }